const CODES = [
  "hr","ba","si","rs","me","mk","al","gr","it","at","hu","de","fr","es","pt","nl","be","lu","ch","li",
  "dk","se","no","fi","is","ie","gb","pl","cz","sk","ro","bg","md","ua","by","lt","lv","ee","ru","tr",
  "cy","mt","us","ca","mx","br","ar","cl","co","pe","uy","py","bo","ec","ve","cr","pa","cu","do","gt",
  "au","nz","jp","cn","kr","in","id","th","vn","ph","my","sg","pk","bd","lk","np","kz","uz","ge","am",
  "az","il","ae","sa","qa","kw","om","jo","lb","eg","ma","dz","tn","ly","za","ng","ke","gh","et","tz",
];

export const FlagsTicker = () => (
  <div
    className="marquee-mask fixed bottom-0 left-0 right-0 z-20 overflow-hidden bg-black/60 backdrop-blur-md border-t border-white/10 py-2"
    data-testid="flags-ticker"
  >
    <div className="marquee-track" style={{ animationDuration: "60s" }}>
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
          {CODES.map((c) => (
            <img
              key={`${copy}-${c}`}
              src={`https://flagcdn.com/w80/${c}.png`}
              alt=""
              loading="lazy"
              className="h-5 sm:h-6 w-auto mx-1.5 sm:mx-2 rounded-[3px] shadow-[0_2px_8px_rgba(0,0,0,0.5)]"
            />
          ))}
        </div>
      ))}
    </div>
  </div>
);
